import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { formatDate } from '@angular/common';
import * as shape from 'd3-shape';
import { MatTableDataSource } from '@angular/material/table';
import { ADMIN_CONSTANT, Breadcrumbs, ResponseBody } from 'src/app/app.model';
import { Observable, Subject } from 'rxjs';
import { LandingService } from './landing.service';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { DashboardService } from '../dashboard.service';
import { College, Course, DashboardData, DashboardDataForCollege, DashboardDataForCourse, TabData, University } from './landing.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { EncryptionService } from 'src/app/encryption.service';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ApplicantDetailsComponent } from './applicant-details/applicant-details.component';
import { ExcelServiceService } from 'src/app/excel-service.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent implements OnInit {

  universityOpenState: boolean = true;
  collegeOpenState: boolean = false;
  courseOpenState: boolean = false;
  university: any;
  college: any;
  breadcrumbsURLConfig: Breadcrumbs[];
  dataSourceForUniversity: MatTableDataSource<University>;
  dataSourceForCollege: MatTableDataSource<College>;
  dataSourceForCourse: MatTableDataSource<Course>;
  loggedUserId: any;
  toggleValue: number = 1;
  areaChart: any;
  doughnutChart: any;
  verticalBarChart: any;
  numberCardsChart: any[];
  chart: any;
  reportBaseUrl: string;
  destroy: Subject<any> = new Subject<any>();

  public resultFoundForUniversity: boolean;
  public resultFoundForCollege: boolean;
  public resultFoundForCourse: boolean;
  public displayedColumnsForUniversity: string[];
  public displayedColumnsForCollege: string[];
  public displayedColumnsForCourse: string[];

  public tabData: any;
  public configurationTabData: any;
  public applicationTabData: any;
  public admissionTabData: any;
  private readonly AESKey: string;


  totalRowsForUniversity: number;
  rowsForUniversity: number;

  totalRowsForCollege: number;
  rowsForCollege: number;

  totalRowsForCourse: number;
  rowsForCourse: number;

  selectedTabIndex: number;
  tabAttributes: any;


  private paginator: MatPaginator;
  maritAllocationbaseUrl: string = environment.meritAllocationBaseUrl;
  @ViewChild(MatPaginator, { static: false }) set paginatorRef(
    paginator: MatPaginator
  ) {
    this.paginator = paginator;
    if (!!paginator) {
      if (this.configurationTabData) {
        if (this.configurationTabData.University.dataSourceForUniversity) this.configurationTabData.University.dataSourceForUniversity.paginator = paginator;
        if (this.configurationTabData.College.dataSourceForCollege) this.configurationTabData.College.dataSourceForCollege.paginator = paginator;
        if (this.configurationTabData.Course.dataSourceForCourse) this.configurationTabData.Course.dataSourceForCourse.paginator = paginator;
      }

      if (this.applicationTabData) {
        if (this.applicationTabData.University.dataSourceForUniversity) this.applicationTabData.University.dataSourceForUniversity.paginator = paginator;
        if (this.applicationTabData.College.dataSourceForCollege) this.applicationTabData.College.dataSourceForCollege.paginator = paginator;
        if (this.applicationTabData.Course.dataSourceForCourse) this.applicationTabData.Course.dataSourceForCourse.paginator = paginator;
      }

      if (this.admissionTabData) {
        if (this.admissionTabData.University.dataSourceForUniversity) this.admissionTabData.University.dataSourceForUniversity.paginator = paginator;
        if (this.admissionTabData.College.dataSourceForCollege) this.admissionTabData.College.dataSourceForCollege.paginator = paginator;
        if (this.admissionTabData.course.dataSourceForCourse) this.admissionTabData.course.dataSourceForCourse.paginator = paginator;
      }
    }
  }

  private sort: MatSort;
  @ViewChild(MatSort, { static: false }) set sortRef(sort: MatSort) {
    this.sort = sort;
    if (!!sort) {
      if (this.configurationTabData) {
        if (this.configurationTabData.University.dataSourceForUniversity) this.configurationTabData.University.dataSourceForUniversity.sort = sort;
        if (this.configurationTabData.College.dataSourceForCollege) this.configurationTabData.College.dataSourceForCollege.sort = sort;
        if (this.configurationTabData.Course.dataSourceForCourse) this.configurationTabData.Course.dataSourceForCourse.sort = sort;
      }

      if (this.applicationTabData) {
        if (this.applicationTabData.University.dataSourceForUniversity) this.applicationTabData.University.dataSourceForUniversity.sort = sort;
        if (this.applicationTabData.College.dataSourceForCollege) this.applicationTabData.College.dataSourceForCollege.sort = sort;
        if (this.applicationTabData.Course.dataSourceForCourse) this.applicationTabData.Course.dataSourceForCourse.sort = sort;
      }

      if (this.admissionTabData) {
        if (this.admissionTabData.University.dataSourceForUniversity) this.admissionTabData.University.dataSourceForUniversity.sort = sort;
        if (this.admissionTabData.College.dataSourceForCollege) this.admissionTabData.College.dataSourceForCollege.sort = sort;
        if (this.admissionTabData.course?.dataSourceForCourse) this.admissionTabData.course.dataSourceForCourse.sort = sort;
      }
    }
  }


  constructor(
    private landingService: LandingService,
    private service: AppService,
    private dashService: DashboardService,
    private excelService: ExcelServiceService,
    private encryptionService: EncryptionService,
    private dialog: MatDialog
  ) {
    this.AESKey = environment.encryptionConfig.AES_KEY;
    let adminconfig = this.service.getToken(ADMIN_CONSTANT.ADMIN_TOKEN_ADMIN_CONFIG);
    this.reportBaseUrl = adminconfig.find((eachConfig: any) => eachConfig.ConfigCode === 'CRYSTAL_RPT_URL')?.ConfigValue ?? environment.reportUrl;

  }

  ngOnInit(): void {
    this.breadcrumbsURLConfig = [
      { name: 'Dashboard', path: '/dashboard/home', active: false },
    ];
    this.loggedUserId = this.service.getToken('USERID');
    this.service.setTitle(`Home`);
    this.selectedTabIndex = 0;
    // this.buildCharts();
    //this.getDashboardData();
    this.onTabChanged();
  }

  getDashBoardData(): void {
    this.landingService
      .onDashboardDataFetch(null)
      .pipe(takeUntil(this.destroy))
      .subscribe(
        (response) => {

          if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
            if (
              !!response.Body.BusinessData.Attributes
            ) {
              // this.populateDataTable(response.Body.BusinessData)
              //data to be processed

              this.tabAttributes = response.Body.BusinessData.Attributes;
              this.populateHeaderData(this.tabAttributes);
              this.populateTableForUniversity(response.Body.BusinessData.UniversityList);
            } else {
              // this.populateDataTable([]);
              this.service.showToast(ADMIN_CONSTANT.NO_RECORDS_FOUND);
            }
          } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
            this.service.showToast(response.Error.ErrorMessage);
          }
        },
        (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
      );
  }



  buildCharts(): void {
    // card chart
    // this.numberCardsChart = [
    //   {
    //     name: 'Total College(s)',
    //     value: '386',
    //     label: 'red',
    //     icon: 'apartment',
    //     trending: 'trending_up',
    //   },
    //   {
    //     name: 'Total Course(s)',
    //     value: '500',
    //     label: 'green',
    //     icon: 'subject',
    //     trending: 'trending_up',
    //   },
    //   {
    //     name: 'Total Students',
    //     value: '50K',
    //     label: 'yellow',
    //     icon: 'person',
    //     trending: 'trending_down',
    //   },
    //   {
    //     name: 'App Users',
    //     value: '1.2M',
    //     label: 'indigo',
    //     icon: 'smartphone',
    //     trending: 'trending_up',
    //   },
    //   {
    //     name: 'Total App Pending(s)',
    //     value: '1.2M',
    //     label: 'indigo',
    //     icon: 'cancel',
    //     trending: 'trending_up',
    //   },
    // ];



    // vertical bar chart
    this.verticalBarChart = {
      view: [undefined, 275],
      xAxis: true,
      yAxis: false,
      scheme: {
        domain: [
          '#f44336',
          '#4caf50',
          '#03a9f4',
          '#673ab7',
          '#009688',
          '#CDDC39',
        ],
      },
      results: [
        {
          name: 'JAN',
          value: 19500,
        },
        {
          name: 'FEB',
          value: 30500,
        },
        {
          name: 'MAR',
          value: 34500,
        },
        {
          name: 'APR',
          value: 22500,
        },
        {
          name: 'MAY',
          value: 29500,
        },
        {
          name: 'JUN',
          value: 39500,
        },
        {
          name: 'JUL',
          value: 25500,
        },
        {
          name: 'AUG',
          value: 38500,
        },
        {
          name: 'SEP',
          value: 41500,
        },
        {
          name: 'OCT',
          value: 38500,
        },
        {
          name: 'NOV',
          value: 32500,
        },
        {
          name: 'DEC',
          value: 29000,
        },
      ],
    };

    // doughnut chart
    this.doughnutChart = {
      legend: true,
      arcWidth: 0.25,
      doughnut: true,
      legendTitle: '',
      legendPosition: 'below',
      scheme: { domain: ['#4FC3F7', '#01579B'] },
      results: [
        {
          name: 'android',
          value: 15000,
        },
        {
          name: 'ios',
          value: 7000,
        },
      ],
    };

    // area chart
    this.areaChart = {
      xAxis: true,
      yAxis: false,
      autoScale: false,
      curve: shape.curveNatural,
      scheme: { domain: ['#01579B'] },
      results: [
        {
          name: 'Visitors',
          series: [
            {
              name: 'JAN',
              value: 19500,
            },
            {
              name: 'FEB',
              value: 30500,
            },
            {
              name: 'MAR',
              value: 34500,
            },
            {
              name: 'APR',
              value: 22500,
            },
            {
              name: 'MAY',
              value: 29500,
            },
            {
              name: 'JUN',
              value: 39500,
            },
            {
              name: 'JUL',
              value: 25500,
            },
            {
              name: 'AUG',
              value: 38500,
            },
            {
              name: 'SEP',
              value: 41500,
            },
            {
              name: 'OCT',
              value: 38500,
            },
            {
              name: 'NOV',
              value: 32500,
            },
            {
              name: 'DEC',
              value: 29000,
            },
          ],
        },
      ],
    };
  }


  populateDataTable(dashboardData: DashboardData): void {
    this.numberCardsChart = [
      {
        name: 'Total University(s)',
        value: dashboardData.Attributes.UniversityCount,
        label: 'indigo',
        icon: 'apartment',
        // trending: 'trending_up',
      },
      {
        name: 'Total College(s)',
        value: dashboardData.Attributes.CollegeCount,
        label: 'green',
        icon: 'school',
        //trending: 'trending_up',
      },

      {
        name: 'Total Course(s)',
        value: dashboardData.Attributes.CourseCount,
        label: 'green',
        icon: 'subject',
        //  trending: 'trending_up',
      },
      {
        name: 'Vacancies',
        value: dashboardData.Attributes.VacancyCount,
        label: 'red',
        icon: 'person',
        // trending: 'trending_down',
      },

    ];
    this.resultFoundForUniversity = !!dashboardData.UniversityList.length;
    this.displayedColumnsForUniversity = !!dashboardData.UniversityList.length
      ? [
        // 'UniversityCode',
        'UniversityName',
        'DistrictName',
        'TotalSeatCount',
        'CourseCount',
        'CollegeCount',
        'EligibilityRuleCompleted',
        'TestSuccessCount',
        'TestFailureCount',
        'NodalSubmissionPending',
        'CollegeyApprovalPending',
        'UniversityApprovalPending',
        'ViewCollege',
      ] : ['NA'];
    let universityList = [];
    for (const university of dashboardData.UniversityList) {
      const {
        UniversityId,
        UniversityCode,
        UniversityName,
        DistrictName,
        TotalSeatCount,
        CourseCount,
        CollegeCount,
        EligibilityRuleCompleted,
        SuccessfulTest,
        UnResolvedFailureCount,
        NodalSubmissionPending,
        CollegeyApprovalPending,
        UniversityApprovalPending,
      } = { ...university };
      universityList = [
        ...universityList,
        {
          UniversityId,
          UniversityCode,
          UniversityName,
          DistrictName,
          TotalSeatCount,
          CourseCount,
          CollegeCount,
          EligibilityRuleCompleted,
          SuccessfulTest,
          UnResolvedFailureCount,
          NodalSubmissionPending,
          CollegeyApprovalPending,
          UniversityApprovalPending,
        },
      ];
    }
    this.dataSourceForUniversity = new MatTableDataSource(universityList);
    this.dataSourceForUniversity.paginator = this.paginator;
    this.dataSourceForUniversity.sort = this.sort;
    this.totalRowsForUniversity = universityList.length;
    this.rowsForUniversity = ADMIN_CONSTANT.ADMIN_SEARCH_PAGE_SIZE;
  }
  ViewCollege(UniversityId) {
    this.dataSourceForCourse = new MatTableDataSource(null);

    var payload = {
      "UniversityId": UniversityId,
      "ObjectType": "Dashboard"
    }
    this.landingService
      .onDashboardCollegeDataFetch(payload)
      .pipe(takeUntil(this.destroy))
      .subscribe(
        (response) => {
          // ;
          if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
            if (
              !!response.Body.BusinessData.CollegeList
            ) {
              this.university = response.Body.BusinessData.CollegeList[0].UniversityName;
              this.populateDataTableForCollege(response.Body.BusinessData);
              this.collegeOpenState = true;
              this.universityOpenState = false;
              //data to be processed
            } else {
              // this.populateDataTable([]);
              this.service.showToast(ADMIN_CONSTANT.NO_RECORDS_FOUND);
            }
          } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
            this.service.showToast(response.Error.ErrorMessage);
          }
        },
        (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
      );
  }

  populateDataTableForCollege(dashboardData: DashboardDataForCollege): void {
    this.resultFoundForCollege = !!dashboardData.CollegeList.length;
    this.displayedColumnsForCollege = !!dashboardData.CollegeList.length
      ? [
        // 'CollegeCode',
        'CollegeName',
        'DistrictName',
        'TotalSeatCount',
        'CourseCount',
        'EligibilityRuleCompleted',
        'TestSuccessCount',
        'TestFailureCount',
        'NodalSubmissionPending',
        'CollegeApprovalPending',
        'UniversityApprovalPending',
        'ViewCourses',
      ] : ['NA'];
    let CollegeList = [];
    for (const college of dashboardData.CollegeList) {
      const {
        CollegeId,
        CollegeCode,
        CollegeName,
        DistrictName,
        TotalSeatCount,
        CourseCount,
        EligibilityRuleCompleted,
        SuccessfulTest,
        UnResolvedTestCount,
        NodalSubmissionPending,
        CollegeyApprovalPending,
        UniversityApprovalPending,
      } = {
        ...college,
      };
      CollegeList = [
        ...CollegeList,
        {
          CollegeId,
          CollegeCode,
          CollegeName,
          DistrictName,
          TotalSeatCount,
          CourseCount,
          EligibilityRuleCompleted,
          SuccessfulTest,
          UnResolvedTestCount,
          NodalSubmissionPending,
          CollegeyApprovalPending,
          UniversityApprovalPending,
        },
      ];
    }
    this.dataSourceForCollege = new MatTableDataSource(CollegeList);
    this.dataSourceForCollege.paginator = this.paginator;
    this.dataSourceForCollege.sort = this.sort;
    this.totalRowsForCollege = CollegeList.length;
    this.rowsForCollege = ADMIN_CONSTANT.ADMIN_SEARCH_PAGE_SIZE;
  }


  ViewCourses(CollegeId) {
    var payload = {
      "CollegeId": CollegeId,
      "ObjectType": "Dashboard"
    }
    this.landingService
      .onDashboardCourseDataFetch(payload)
      .pipe(takeUntil(this.destroy))
      .subscribe(
        (response) => {
          // ;
          if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
            if (
              !!response.Body.BusinessData.CourseList
            ) {
              this.college = response.Body.BusinessData.CourseList[0].CollegeName;
              this.populateDataTableForCourse(response.Body.BusinessData);
              [this.universityOpenState, this.collegeOpenState] = Array(2).fill(false);
              this.courseOpenState = true;
              //data to be processed
            } else {
              // this.populateDataTable([]);
              this.service.showToast(ADMIN_CONSTANT.NO_RECORDS_FOUND);
            }
          } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
            this.service.showToast(response.Error.ErrorMessage);
          }
        },
        (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
      );
  }
  populateDataTableForCourse(dashboardData: DashboardDataForCourse): void {
    this.resultFoundForCourse = !!dashboardData.CourseList.length;
    this.displayedColumnsForCourse = !!dashboardData.CourseList.length
      ? [
        // 'CourseCode',
        'CourseName',
        'CourseType',
        'TotalSeatCount',
        'EligibilityRuleCompleted',
        'TestSuccessCount',
        'TestFailureCount',
        'NodalSubmissionPending',
        'CollegeApprovalPending',
        'UniversityApprovalPending',
        'action',
      ] : ['NA'];
    let CourseList = [];
    for (const course of dashboardData.CourseList) {
      const {
        CollegeCourseId,
        CourseCode,
        CourseName,
        CourseType,
        TotalSeatCount,
        EligibilityRuleCompleted,
        TestSuccessCount,
        UnresolvedFailureCount,
        NodalSubmissionPending,
        CollegeApprovalPending,
        UniversityApprovalPending,
      } = { ...course };
      CourseList = [
        ...CourseList,
        {
          CollegeCourseId,
          CourseCode,
          CourseName,
          CourseType,
          TotalSeatCount,
          EligibilityRuleCompleted,
          TestSuccessCount,
          UnresolvedFailureCount,
          NodalSubmissionPending,
          CollegeApprovalPending,
          UniversityApprovalPending,
        },
      ];
    }
    this.dataSourceForCourse = new MatTableDataSource(CourseList);
    this.dataSourceForCourse.paginator = this.paginator;
    this.dataSourceForCourse.sort = this.sort;
    this.totalRowsForCourse = CourseList.length;
    this.rowsForCourse = ADMIN_CONSTANT.ADMIN_SEARCH_PAGE_SIZE;
  }

  onToggleChange(event: any): void {
    this.toggleValue = event.checked ? 1 : 0;
    if (this.selectedTabIndex == 1 || this.selectedTabIndex == 2) {
      this.getApplicationAdmissionDashbordFetch();
    }
    // this.initComponent();
    // console.log('selectedTabIndex:', this.selectedTabIndex);
    // console.log('Toggle value changed:', this.toggleValue);
  }

  onTabChanged($event?: any) {
    // console.log('llllll', $event, this.selectedTabIndex);
    // this.selectedTabIndex = $event.index;
    if (this.selectedTabIndex === 0) {
      this.configurationTabData = new TabData(this.selectedTabIndex);
      [this.applicationTabData, this.admissionTabData] = Array(2).fill(false);
    } else if (this.selectedTabIndex === 1) {
      this.applicationTabData = new TabData(this.selectedTabIndex);
      [this.configurationTabData, this.admissionTabData] = Array(2).fill(false);
    } else {
      this.admissionTabData = new TabData(this.selectedTabIndex);
      [this.configurationTabData, this.applicationTabData] = Array(2).fill(false);
    }
    // this.tabData = new TabData(this.selectedTabIndex);
    // this.tabData.TabIndex = this.selectedTabIndex;
    if (this.selectedTabIndex) {
      this.getApplicationAdmissionDashbordFetch();
    } else {
      this.getDashBoardData();
    }
  }

  getApplicationAdmissionDashbordFetch(): void {
    this.landingService
      .onUserAdminDashboardRunFetch({ ActiveRunCycleFlag: this.toggleValue == 1 ? 1 : 0 })
      .pipe(takeUntil(this.destroy))
      .subscribe(
        (response) => {
          if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
            if (
              !!response.Body.BusinessData.Attributes
            ) {
              this.tabAttributes = response.Body.BusinessData.Attributes;
              this.populateHeaderData(this.tabAttributes);
              this.populateTableForUniversity(response.Body.BusinessData.UniversityList);
            } else {
              this.service.showToast(ADMIN_CONSTANT.NO_RECORDS_FOUND);
            }
          } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
            this.service.showToast(response.Error.ErrorMessage);
          }
        },
        (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
      );
  }

  public GetCollege(unversityId: number) {
    const payload = {
      ObjectType: 'Dashboard',
      UniversityId: unversityId,
    };
    if (this.selectedTabIndex === 0) {
      this.landingService
        .onDashboardCollegeDataFetch(payload)
        .pipe(takeUntil(this.destroy))
        .subscribe(
          (response) => {
            // ;
            if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
              if (
                !!response.Body.BusinessData.CollegeList.length
              ) {
                this.university = response.Body.BusinessData.CollegeList[0].UniversityName;
                this.populateTableForCollege(response.Body.BusinessData.CollegeList);
              } else {
                this.service.showToast(ADMIN_CONSTANT.NO_RECORDS_FOUND);
              }
            } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
              this.service.showToast(response.Error.ErrorMessage);
            }
          },
          (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
        );
    } else {
      let payLoadModified = { ...payload, ActiveRunCycleFlag: this.toggleValue == 1 ? 1 : 0 }
      this.landingService
        .onUserAdminDashboardRunCollege(payLoadModified)
        .pipe(takeUntil(this.destroy))
        .subscribe(
          (response) => {
            if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
              if (
                !!response.Body.BusinessData.CollegeList.length
              ) {
                this.university = response.Body.BusinessData.CollegeList[0].UniversityName;
                this.populateTableForCollege(response.Body.BusinessData.CollegeList);
              } else {
                this.service.showToast(ADMIN_CONSTANT.NO_RECORDS_FOUND);
              }
            } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
              this.service.showToast(response.Error.ErrorMessage);
            }
          },
          (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
        );
    }
  }

  public GetCourse(collegeId: number) {
    const payload = {
      ObjectType: 'Dashboard',
      CollegeId: collegeId,
    };
    if (this.selectedTabIndex === 0) {
      this.landingService
        .onDashboardCourseDataFetch(payload)
        .pipe(takeUntil(this.destroy))
        .subscribe(
          (response) => {
            // ;
            if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
              if (
                !!response.Body.BusinessData.CourseList.length
              ) {
                this.college = response.Body.BusinessData.CourseList[0].CollegeName;
                this.populateTableForCourse(response.Body.BusinessData.CourseList);
              } else {
                this.service.showToast(ADMIN_CONSTANT.NO_RECORDS_FOUND);
              }
            } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
              this.service.showToast(response.Error.ErrorMessage);
            }
          },
          (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
        );
    } else {
      let payLoadModified = { ...payload, ActiveRunCycleFlag: this.toggleValue == 1 ? 1 : 0 }
      this.landingService
        .onUserAdminDashboardRunCourse(payLoadModified)
        .pipe(takeUntil(this.destroy))
        .subscribe(
          (response) => {
            if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
              if (
                !!response.Body.BusinessData.CourseList.length
              ) {
                this.college = response.Body.BusinessData.CourseList[0].CollegeName;
                this.populateTableForCourse(response.Body.BusinessData.CourseList);
              } else {
                this.service.showToast(ADMIN_CONSTANT.NO_RECORDS_FOUND);
              }
            } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
              this.service.showToast(response.Error.ErrorMessage);
            }
          },
          (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
        );
    }
  }

  private populateHeaderData(attributeData: any) {
    if (this.selectedTabIndex === 0) {
      this.configurationTabData.HeaderData = [
        {
          name: 'Total University(s)',
          value: attributeData.UniversityCount,
          label: 'indigo',
          icon: 'apartment',
          // trending: 'trending_up',
        },
        {
          name: 'Total College(s)',
          value: attributeData.CollegeCount,
          label: 'green',
          icon: 'school',
          //trending: 'trending_up',
        },
        {
          name: 'Total Course(s)',
          value: attributeData.CourseCount,
          label: 'green',
          icon: 'subject',
          //  trending: 'trending_up',
        },
        {
          name: 'Vacancies',
          value: attributeData.VacancyCount,
          label: 'red',
          icon: 'person',
          // trending: 'trending_down',
        },
      ];
    } else if (this.selectedTabIndex === 1) {
      this.applicationTabData.HeaderData = [
        {
          name: 'Total Seat(s)',
          value: attributeData.TotalSeatCount,
          label: 'indigo',
          icon: 'event_seat',
          // trending: 'trending_up',
        },
        // {
        //   name: 'Total Registration(s)',
        //   value: attributeData.TotalRegistrationCount,
        //   label: 'green',
        //   icon: 'list',
        //   //trending: 'trending_up',
        // },
        {
          name: 'Total Application(s)',
          value: attributeData.TotalApplicationCount,
          label: 'red',
          icon: 'subject',
          //  trending: 'trending_up',
        },
      ];
      this.applicationTabData.AttributeData = attributeData;
    } else if (this.selectedTabIndex === 2) {
      this.admissionTabData.HeaderData = [
        {
          name: 'Total Seat(s)',
          value: attributeData.TotalSeatCount,
          label: 'indigo',
          icon: 'event_seat',
          // trending: 'trending_up',
        },
        {
          name: 'Total Vacant(s)',
          value: attributeData.TotalVacantCount,
          label: 'green',
          icon: 'list',
          //trending: 'trending_up',
        },
        {
          name: 'Total Allotted Seat(s)',
          value: attributeData.TotalAllottedSeatCount,
          label: 'red',
          icon: 'subject',
          //  trending: 'trending_up',
        },
        {
          name: 'Total Admitted Seat(s)',
          value: attributeData.TotalAdmittedSeatCount,
          label: 'red',
          icon: 'subject',
        },
        {
          name: 'Total Confirmation Count',
          value: attributeData.TotalConfirmationCount,
          label: 'green',
          icon: 'subject',
        },
        {
          name: 'Total College Cancelation Count',
          value: attributeData.TotalCollegeCancelationCount,
          label: 'red',
          icon: 'subject',
        },
      ];
    }
  }

  private populateTableForUniversity(objectData: any) {
    if (this.selectedTabIndex === 0) {
      this.configurationTabData.University.universityOpenState = true;
      this.configurationTabData.College.collegeOpenState = false;
      this.configurationTabData.Course.courseOpenState = false;

      this.configurationTabData.University.resultFoundForUniversity = !!objectData.length;
      this.configurationTabData.University.dataSourceForUniversity = new MatTableDataSource(objectData);
      // this.configurationTabData.University.dataSourceForUniversity.paginator = this.paginator;
      this.configurationTabData.University.dataSourceForUniversity.sort = this.sort;
      this.configurationTabData.University.dataCountForUniversity = objectData.length;
      this.configurationTabData.University.dataRowsForUniversity = ADMIN_CONSTANT.ADMIN_DETAIL_PAGE_SIZE;
      this.configurationTabData.University.displayedColumnsForUniversity = this.configurationTabData.University.resultFoundForUniversity ? [
        // 'UniversityCode',
        'UniversityName',
        'DistrictName',
        'TotalSeatCount',
        'CourseCount',
        'CollegeCount',
        'EligibilityRuleCompleted',
        'TestSuccessCount',
        'TestFailureCount',
        'NodalSubmissionPending',
        'CollegeyApprovalPending',
        'UniversityApprovalPending',
        'ViewCollege',
      ] : ['NA'];
    } else if (this.selectedTabIndex === 1) {
      this.applicationTabData.University.universityOpenState = true;
      this.applicationTabData.College.collegeOpenState = false;
      this.applicationTabData.Course.courseOpenState = false;

      this.applicationTabData.University.resultFoundForUniversity = !!objectData.length;
      this.applicationTabData.University.dataSourceForUniversity = new MatTableDataSource(objectData);
      // this.applicationTabData.University.dataSourceForUniversity.paginator = this.paginator;
      this.applicationTabData.University.dataSourceForUniversity.sort = this.sort;
      this.applicationTabData.University.dataCountForUniversity = objectData.length;
      this.applicationTabData.University.dataRowsForUniversity = ADMIN_CONSTANT.ADMIN_DETAIL_PAGE_SIZE;
      this.applicationTabData.University.displayedColumnsForUniversity = this.applicationTabData.University.resultFoundForUniversity ? [
        // 'UniversityCode',
        'UniversityName',
        'DistrictName',
        'TotalSeatCount',
        'TotalApplicationCount',
        'AvgApplicationPreference',
        'ViewCollege',
      ] : ['NA'];
    } else if (this.selectedTabIndex === 2) {
      this.admissionTabData.University.universityOpenState = true;
      this.admissionTabData.College.collegeOpenState = false;
      this.admissionTabData.Course.courseOpenState = false;

      this.admissionTabData.University.resultFoundForUniversity = !!objectData.length;
      this.admissionTabData.University.dataSourceForUniversity = new MatTableDataSource(objectData);
      // this.admissionTabData.University.dataSourceForUniversity.paginator = this.paginator;
      this.admissionTabData.University.dataSourceForUniversity.sort = this.sort;
      this.admissionTabData.University.dataCountForUniversity = objectData.length;
      this.admissionTabData.University.dataRowsForUniversity = ADMIN_CONSTANT.ADMIN_DETAIL_PAGE_SIZE;
      this.admissionTabData.University.displayedColumnsForUniversity = this.admissionTabData.University.resultFoundForUniversity ? [
        // 'UniversityCode',
        'UniversityName',
        'DistrictName',
        'TotalSeatCount',
        'TotalVacantCount',
        'TotalAllottedSeatCount',
        'TotalAdmittedSeatCount',
        'TotalConfirmationCount',
        'TotalCollegeCancelationCount',
        'ViewCollege',
      ] : ['NA'];
    }
  }

  private populateTableForCollege(objectData: any) {
    if (this.selectedTabIndex === 0) {
      this.configurationTabData.College.collegeOpenState = true;
      this.configurationTabData.University.universityOpenState = false;
      this.configurationTabData.Course.courseOpenState = false;

      this.configurationTabData.College.resultFoundForCollege = !!objectData.length;
      this.configurationTabData.College.dataSourceForCollege = new MatTableDataSource(objectData);
      // this.configurationTabData.College.dataSourceForCollege.paginator = this.paginator;
      this.configurationTabData.College.dataSourceForCollege.sort = this.sort;
      this.configurationTabData.College.dataCountForCollege = objectData.length;
      this.configurationTabData.College.dataRowsForCollege = ADMIN_CONSTANT.ADMIN_DETAIL_PAGE_SIZE;
      this.configurationTabData.College.displayedColumnsForCollege = this.configurationTabData.College.resultFoundForCollege ? [
        // 'CollegeCode',
        'CollegeName',
        'DistrictName',
        'TotalSeatCount',
        'CourseCount',
        'EligibilityRuleCompleted',
        'TestSuccessCount',
        'TestFailureCount',
        'NodalSubmissionPending',
        'CollegeApprovalPending',
        'UniversityApprovalPending',
        'ViewCourses',
      ] : ['NA'];
    } else if (this.selectedTabIndex === 1) {
      this.applicationTabData.College.collegeOpenState = true;
      this.applicationTabData.University.universityOpenState = false;
      this.applicationTabData.Course.courseOpenState = false;

      this.applicationTabData.College.resultFoundForCollege = !!objectData.length;
      this.applicationTabData.College.dataSourceForCollege = new MatTableDataSource(objectData);
      // this.applicationTabData.College.dataSourceForCollege.paginator = this.paginator;
      this.applicationTabData.College.dataSourceForCollege.sort = this.sort;
      this.applicationTabData.College.dataCountForCollege = objectData.length;
      this.applicationTabData.College.dataRowsForCollege = ADMIN_CONSTANT.ADMIN_DETAIL_PAGE_SIZE;
      this.applicationTabData.College.displayedColumnsForCollege = this.applicationTabData.College.resultFoundForCollege && this.toggleValue == 0 ? [
        // 'CollegeCode',
        'CollegeName',
        'DistrictName',
        'TotalSeatCount',
        'TotalApplicationCount',
        'AvgApplicationPreference',
        'ViewCourses',
      ] : this.applicationTabData.College.resultFoundForCollege && this.toggleValue == 1 ? [
        // 'CollegeCode',
        'CollegeName',
        'DistrictName',
        'TotalSeatCount',
        'TotalVacantCount',
        'TotalApplicationCount',
        'AvgApplicationPreference',
        'ViewCourses',
      ] : ['NA'];
    } else if (this.selectedTabIndex === 2) {
      this.admissionTabData.College.collegeOpenState = true;
      this.admissionTabData.University.universityOpenState = false;
      this.admissionTabData.Course.courseOpenState = false;

      this.admissionTabData.College.resultFoundForCollege = !!objectData.length;
      this.admissionTabData.College.dataSourceForCollege = new MatTableDataSource(objectData);
      // this.admissionTabData.College.dataSourceForCollege.paginator = this.paginator;
      this.admissionTabData.College.dataSourceForCollege.sort = this.sort;
      this.admissionTabData.College.dataCountForCollege = objectData.length;
      this.admissionTabData.College.dataRowsForCollege = ADMIN_CONSTANT.ADMIN_DETAIL_PAGE_SIZE;
      this.admissionTabData.College.displayedColumnsForCollege = this.admissionTabData.College.resultFoundForCollege ? [
        // 'CollegeCode',
        'CollegeName',
        'DistrictName',
        'TotalSeatCount',
        'TotalVacantCount',
        'TotalAllottedSeatCount',
        'TotalAdmittedSeatCount',
        'TotalConfirmationCount',
        'TotalCollegeCancelationCount',
        'vacancyList',
        'CollegeAdmissionList',
        'admissionList',
        'allData',
        'allDataExcel',
        'allResDataExcel',
        'confirmList',
        'ViewCourses',
      ] : ['NA'];
    }
  }

  private populateTableForCourse(objectData: any) {
    if (this.selectedTabIndex === 0) {
      this.configurationTabData.Course.courseOpenState = true;
      this.configurationTabData.College.collegeOpenState = false;
      this.configurationTabData.University.universityOpenState = false;

      this.configurationTabData.Course.resultFoundForCourse = !!objectData.length;
      this.configurationTabData.Course.dataSourceForCourse = new MatTableDataSource(objectData);
      // this.configurationTabData.Course.dataSourceForCourse.paginator = this.paginator;
      this.configurationTabData.Course.dataSourceForCourse.sort = this.sort;
      this.configurationTabData.Course.dataCountForCourse = objectData.length;
      this.configurationTabData.Course.dataRowsForCourse = ADMIN_CONSTANT.ADMIN_DETAIL_PAGE_SIZE;
      this.configurationTabData.Course.displayedColumnsForCourse = this.configurationTabData.Course.resultFoundForCourse ? [
        // 'CourseCode',
        'CourseName',
        // 'CourseType',
        'TotalSeatCount',
        'EligibilityRuleCompleted',
        'TestSuccessCount',
        'TestFailureCount',
        'NodalSubmissionPending',
        'CollegeApprovalPending',
        'UniversityApprovalPending',
        'action',
      ] : ['NA'];
    } else if (this.selectedTabIndex === 1) {
      this.applicationTabData.Course.courseOpenState = true;
      this.applicationTabData.College.collegeOpenState = false;
      this.applicationTabData.University.universityOpenState = false;

      this.applicationTabData.Course.resultFoundForCourse = !!objectData.length;
      this.applicationTabData.Course.dataSourceForCourse = new MatTableDataSource(objectData);
      // this.applicationTabData.Course.dataSourceForCourse.paginator = this.paginator;
      this.applicationTabData.Course.dataSourceForCourse.sort = this.sort;
      this.applicationTabData.Course.dataCountForCourse = objectData.length;
      this.applicationTabData.Course.dataRowsForCourse = ADMIN_CONSTANT.ADMIN_DETAIL_PAGE_SIZE;
      this.applicationTabData.Course.displayedColumnsForCourse = this.applicationTabData.Course.resultFoundForCourse && this.toggleValue == 0 ? [
        // 'CourseCode',
        'CourseName',
        // 'CourseType',
        'TotalSeatCount',
        'TotalApplicationCount',
        // 'TestSuccessCount',
        // 'TestFailureCount',
        'AvgApplicationPreference',
        'MeritListGenerated',
        'AllocationListGenerated',
        'action',
        'ApplicationDetails',
      ] : this.applicationTabData.Course.resultFoundForCourse && this.toggleValue == 1 ? [
        // 'CourseCode',
        'CourseName',
        // 'CourseType',
        'TotalSeatCount',
        'TotalVacantCount',
        'TotalApplicationCount',
        // 'TestSuccessCount',
        // 'TestFailureCount',
        'AvgApplicationPreference',
        'MeritListGenerated',
        'AllocationListGenerated',
        'action',
        'ApplicationDetails',
      ] : ['NA'];
    } else if (this.selectedTabIndex === 2) {
      this.admissionTabData.Course.courseOpenState = true;
      this.admissionTabData.College.collegeOpenState = false;
      this.admissionTabData.University.universityOpenState = false;

      this.admissionTabData.Course.resultFoundForCourse = !!objectData.length;
      this.admissionTabData.Course.dataSourceForCourse = new MatTableDataSource(objectData);
      // this.admissionTabData.Course.dataSourceForCourse.paginator = this.paginator;
      this.admissionTabData.Course.dataSourceForCourse.sort = this.sort;
      this.admissionTabData.Course.dataCountForCourse = objectData.length;
      this.admissionTabData.Course.dataRowsForCourse = ADMIN_CONSTANT.ADMIN_DETAIL_PAGE_SIZE;
      this.admissionTabData.Course.displayedColumnsForCourse = this.admissionTabData.Course.resultFoundForCourse ? [
        // 'CourseCode',
        'CourseName',
        // 'CourseType',
        'TotalSeatCount',
        // 'TestSuccessCount',
        // 'TestFailureCount',
        'TotalVacantCount',
        'TotalAllottedSeatCount',
        'TotalAdmittedSeatCount',
        'TotalConfirmationCount',
        'TotalCollegeCancelationCount',
        'MeritListGenerated',
        'vacancyList',
        'CollegeAdmissionList',
        'confirmList',
        // 'action',
      ] : ['NA'];
    }
  }
  applyFilter(filterValue: string, dataSourse: any) {
    filterValue = filterValue.trim().toLowerCase();
    dataSourse.filter = filterValue;
  }

  public callAllocation(callingFrm: string): void {
    this.landingService
      .onExecuteAllocationProcess({}, callingFrm)
      .pipe(takeUntil(this.destroy))
      .subscribe(
        (response) => {
          if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
            this.service.showToast(response.Body.BusinessData.Object.Message);
            if (callingFrm === 'GenerateMeritList') {
              this.applicationTabData.AttributeData.MeritListGenerated = 1;
            } else if (callingFrm === 'PublishMeritList') {
              this.applicationTabData.AttributeData.MeritListPublished = 1;
            } else if (callingFrm === 'GenerateAllocationList') {
              this.applicationTabData.AttributeData.AllocationListGenerated = 1;
            } else if (callingFrm === 'PublishAllocationList') {
              this.applicationTabData.AttributeData.AllocationListPublished = 1;
            }
            this.applicationTabData.Course.courseOpenState = false;
          } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
            this.service.showToast(response.Error.ErrorMessage);
          }
        },
        (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
      );
  }

  private getNowUTCUnFormated(): any {
    const now = new Date();
    return (new Date(now.getTime() + (now.getTimezoneOffset() * 60000)));
  }

  private openReport(reportId: string, outputPdfFileName: string, reportParamObj: object) {
    // const AESKey = '98eb956cd9364a88b6a6048439983370';
    // const reportBaseUrl = 'http://repserver.applythrunet.co.in/PrintReport/ShowReport';
    const reportBaseUrl = environment.reportUrl;

    const twentyMinutesLater = this.getNowUTCUnFormated();
    twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + 20);
    const addeddate = formatDate(twentyMinutesLater, 'yyyy-MM-dd HH:mm:ss', 'en');

    const param = {
      reportParam: reportParamObj,
      outputFileName: outputPdfFileName,
      reportType: 'PDF',
      linkExpiryOn: addeddate,
    };
    const encryptText = this.encryptionService.Encrypt(JSON.stringify(param), this.AESKey);
    console.log(JSON.stringify(param));
    console.log(encryptText);
    const URL = this.reportBaseUrl + '?reportcode=' + reportId + '&param=' + encodeURIComponent(encryptText);
    window.open(URL);
  }

  public generateReport(item: any, reportType: string) {
    if (this.selectedTabIndex === 1) {
      const reportId = reportType === 'Merit' ? '74274E06-B8FA-4C71-8F04-3A9DEA5F5625' : reportType === 'Application' ? 'd1df7972-db9f-4209-9a70-7a4a0a3ad033' : '72449D25-DB50-40DB-BE79-2FE3C60C4F7E';
      const outputfilename = `${reportType}List.pdf`;
      const reportParam = { CollegeCourseId: item.CollegeCourseId };
      if (reportType == 'Application') {
        reportParam['RunCycleID'] = item?.RunCycleId;
        reportParam['UniversityID'] = null;
        reportParam['DistrictID'] = null;
        reportParam['CollegeId'] = null;
      } else {
        reportParam['ActiveRunCycleId'] = item?.RunCycleId
      }
      this.openReport(reportId, outputfilename, reportParam);
    } else if (this.selectedTabIndex === 2) {
      const reportId = reportType === 'Vacancy' ? '5ed9454d-c8ff-4640-8deb-fd412849e3d6' : reportType === 'VacancyCourse' ? '5ed9454d-c8ff-4640-8deb-fd412849e3d6' : reportType === 'AdmissionCollege' ? '878ad711-ec75-41a9-b8f0-0c299dba5134' : 'c75b6508-6673-471d-b552-a0e2d36ed9f2';
      const outputfilename = `${reportType}List.pdf`;
      const reportParam = { UsrId: this.loggedUserId, DistrictId: null, UniversityId: null };
      if (reportType === "Vacancy") {
        reportParam['CollegeCourseId'] = null;
        reportParam['CollegeId'] = item?.CollegeId;
        reportParam['ViewCategory'] = "VacancySummary";
      } else if (reportType === "VacancyCourse") {
        reportParam['CollegeCourseId'] = item?.CollegeCourseId;
        reportParam['CollegeId'] = null;
        reportParam['ViewCategory'] = "VacancySummary";
      } else if (reportType === "AdmissionCollege") {
        reportParam['CollegeCourseId'] = null;
        reportParam['CollegeId'] = item?.CollegeId;
        reportParam['ViewCategory'] = "AdmissionRpt";
      } else {
        reportParam['ViewCategory'] = "AdmissionRpt";
        reportParam['CollegeId'] = null;
        reportParam['CollegeCourseId'] = item?.CollegeCourseId;
      }
      // const reportParama = {
      //   ViewCategory: 'AdmissionRpt', UsrId: this.loggedUserId, DistrictId: null, UniversityId: null, CollegeId: null, CollegeCourseId: item.CollegeCourseId
      // };
      this.openReport(reportId, outputfilename, reportParam);
    }

  }
  showMeritListReportNew = (CollegeCourseId: number, routeString: string) => {
    const meritAloocationListUrl = `${this.maritAllocationbaseUrl}${routeString}/${CollegeCourseId}${'_P1_A1'}.pdf`;
    window.open(meritAloocationListUrl, '_blank');
  }
  generateXLSXReport(tab: string, accordianType: string): void {
    let data: any = null;
    if (tab.toLocaleLowerCase() === 'configuration') {
      if (accordianType.toLocaleLowerCase() === 'university') {
        data = this.configurationTabData.University.dataSourceForUniversity.filteredData;
      } else if (accordianType.toLocaleLowerCase() === 'college') {
        data = this.configurationTabData.College.dataSourceForCollege.filteredData;
      } else if (accordianType.toLocaleLowerCase() === 'course') {
        data = this.configurationTabData.Course.dataSourceForCourse.filteredData;
      }
    } else if (tab.toLocaleLowerCase() === 'application') {
      if (accordianType.toLocaleLowerCase() === 'university') {
        data = this.applicationTabData.University.dataSourceForUniversity.filteredData;
      } else if (accordianType.toLocaleLowerCase() === 'college') {
        data = this.applicationTabData.College.dataSourceForCollege.filteredData;
      } else if (accordianType.toLocaleLowerCase() === 'course') {
        data = this.applicationTabData.Course.dataSourceForCourse.filteredData;
      }
    } else if (tab.toLocaleLowerCase() === 'admission') {
      if (accordianType.toLocaleLowerCase() === 'university') {
        data = this.admissionTabData.University.dataSourceForUniversity.filteredData;
      } else if (accordianType.toLocaleLowerCase() === 'college') {
        data = this.admissionTabData.College.dataSourceForCollege.filteredData;
      } else if (accordianType.toLocaleLowerCase() === 'course') {
        data = this.admissionTabData.Course.dataSourceForCourse.filteredData;
      }
    }

    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, accordianType);

    /* save to file */
    XLSX.writeFile(wb, `${tab}${accordianType}Report_${(new Date()).getTime()}.xlsx`);
  }
  callCollegeAdmissionList(item: any): void {
    // console.log(item)
    if (!!item) {
      const payload = {
        CollegeCourseId: item?.CollegeCourseId ?? null,
        CollegeId: item?.CollegeId ?? null
      }
      this.landingService
        .onCollegeAdmissionList(payload)
        .pipe(takeUntil(this.destroy))
        .subscribe(
          (response) => {
            if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
              if (response.Body?.BusinessData?.Collection && !!response.Body.BusinessData?.Collection.length) {
                let fileName = `Admission_Confirmation_${item?.CollegeId ?? item?.CollegeCourseId}_${item?.CollegeCode ?? item?.CourseCode}`
                this.exportToExcel(response.Body.BusinessData?.Collection, fileName)
              } else {
                this.service.showToast('No Data Found');
              }
            } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
              this.service.showToast(response.Error.ErrorMessage);
            }
          },
          (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
        );
    }
  }
   callCollegeAllotedList(item: any): void {
    // console.log(item)
    if (!!item) {
      const payload = {
        CollegeCourseId: item?.CollegeCourseId ?? null,
        CollegeId: item?.CollegeId ?? null,
        ApplicationStatusId: item?.ApplicationStatusId ?? null,
		    ApplicationStatusCode:  'A2'
      }
      this.landingService
        .onCollegeAdmissionList(payload)
        .pipe(takeUntil(this.destroy))
        .subscribe(
          (response) => {
            if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
              if (response.Body?.BusinessData?.Collection && !!response.Body.BusinessData?.Collection.length) {
                let fileName = `Alloted_${item?.CollegeId ?? item?.CollegeCourseId}_${item?.CollegeCode ?? item?.CourseCode}`
                this.exportToExcel(response.Body.BusinessData?.Collection, fileName)
              } else {
                this.service.showToast('No Data Found');
              }
            } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
              this.service.showToast(response.Error.ErrorMessage);
            }
          },
          (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
        );
    }
  }
  callCollegeVacancyList(item: any): void {
    // console.log(item)
    if (!!item) {
      const payload = {
        CollegeCourseId: item?.CollegeCourseId ?? null,
        CollegeId: item?.CollegeId ?? null
      }
      this.landingService
        .onGetVacacyList(payload)
        .pipe(takeUntil(this.destroy))
        .subscribe(
          (response) => {
            if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
              if (response.Body?.BusinessData?.Collection && !!response.Body.BusinessData?.Collection.length) {
                let fileName = `Vacancy_List_${item?.CollegeId ?? item?.CollegeCourseId}_${item?.CollegeCode ?? item?.CourseCode}`
                this.exportToExcel(response.Body.BusinessData?.Collection, fileName)
              } else {
                this.service.showToast('No Data Found');
              }
            } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
              this.service.showToast(response.Error.ErrorMessage);
            }
          },
          (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
        );
    }
  }
  exportToExcel(collData: any, fileName: string): void {
    if (collData) {
      this.excelService.exportAsExcelFile(collData, fileName);
    }
  }

  openDialog(couId: number, runCId: number) {
    const dialogRef = this.dialog.open(ApplicantDetailsComponent, {
      width: '92%',
      maxWidth: '92%',
      hasBackdrop: true,
      disableClose: true,
      data: {
        CollegeCourseId: couId,
        RunCycleId: runCId,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  getAllDataExcel(collegeId:number){
    const payload = {
      JSONOutputFlag: 1,
      CollegeId: collegeId
    }
    this.landingService
      .onCourseAdmissionDetail(payload)
      .pipe(takeUntil(this.destroy))
      .subscribe(
        (response) => {
          if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
            if (response.Body?.BusinessData?.Collection && !!response.Body.BusinessData?.Collection.length) {
              let fileName = `TotalAdmiitedData_${collegeId}`
              this.exportToExcel(response.Body.BusinessData?.Collection, fileName)
            } else {
              this.service.showToast('No Data Found');
            }
          } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
            this.service.showToast(response.Error.ErrorMessage);
          }
        },
        (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
      );
  }

}
